<div class="page" [class.page--basic]="!isLoggedIn" [class.page--primary-nav-open]="isMobileMenuOpen && isLoggedIn">
  <app-header></app-header>
  <div class="page-width page__inner-wrap">
    <app-nav *ngIf="isLoggedIn && !isAssessment" class="nav primary-nav"></app-nav>
    <main id="main-content" class="main" [class.main--stand-alone]="!isLoggedIn && !isBadge" [class.has-spinner]="isLoading" role="main">
      <span [style.display]="isLoading ? 'none' : ''">
        <router-outlet></router-outlet>
      </span>
      <app-loading-spinner></app-loading-spinner>
    </main>
  </div>
  <app-footer></app-footer>
</div>